import React from "react";
import { AuthProvider } from "../features/auth/AuthContext";

const AppProviders = ({ children }) => {
  return <AuthProvider>{children}</AuthProvider>;
};

export default AppProviders;
